module.exports = __webpack_public_path__ + "img/img_prize1.95181860.png";